import WeixinLoginUser from "./WeixinLoginUser";
export default WeixinLoginUser;
